import React from "react";
import { UserOutlined } from "@ant-design/icons";
import styles from "./postmatch-table-render.module.css";
import { TruncatedText } from "../truncated-text/truncated-text";
import { getPlaceholderValue } from "../../utils/get-placeholder-value/get-placeholder-value";

export function PostmatchTableDeveloperActivity({
  developerRecord,
  onClickDeveloper,
  disableDDP,
  isTruncationEnabled,
}: any) {
  const name = developerRecord?.name;
  const img = developerRecord?.img;
  const developerId = developerRecord?.developerId;
  const developerIdHash = developerRecord?.developerIdHash;
  const jobId = developerRecord?.jobId;

  const isDeveloperClickable =
    name && developerId && developerIdHash && jobId && !disableDDP;

  const developerRecordClassName = `${styles.developerRecord} ${
    isDeveloperClickable ? styles.developerRecordButton : ""
  }`;

  const nameClassName = `${styles.name} ${
    isDeveloperClickable ? styles.nameButton : ""
  }`;

  return (
    <div
      className={developerRecordClassName}
      onClick={onClickDeveloper}
      data-testid="postmatch-developer"
    >
      {img ? (
        <img src={img} />
      ) : (
        <div className={styles.placeholder}>
          <UserOutlined />
        </div>
      )}
      <div className={nameClassName}>
        {isTruncationEnabled ? (
          <TruncatedText text={name} />
        ) : (
          getPlaceholderValue(name)
        )}
      </div>
    </div>
  );
}
